// import REST from '../config';
import globalData from './globalData';
const REST = require("../config/index");

const axios = require('axios');
let sskey = '';

const Http = (options = {}) => {
	const instance = axios.create({
		baseURL: REST.rest,
		method: 'get'
	});

	if (!globalData.sessionKey) {
		sskey = sessionStorage.getItem('sskey');
		globalData.sessionKey = sskey;
	} else {
		sskey = globalData.sessionKey;
	}

	instance.defaults.headers.common['Authorization'] = `${sskey}`;

	instance.interceptors.response.use(function (response) {
		// Do something with response data
		return response;
	}, function (error) {
		console.log(error, 'http error')
		if (error.response && error.response.data && error.response.status === 401) {
			// window.location = window.location.origin;
			window.location.replace(window.location.origin);
		}
		return Promise.reject(error);
	});

	return instance.request(options);
}


export default {
	Http,
	sskey
};



// WEBPACK FOOTER //
// ./src/service/http.js